export {};

const customViewportCorrectionVariable = 'vh';

function setViewportProperty(doc: HTMLElement) {
  const customVar = '--' + (customViewportCorrectionVariable || 'vh');
  let prevClientHeight: number;

  function handleResize() {
    const clientHeight = doc.clientHeight;

    if (clientHeight === prevClientHeight) {
      return;
    }

    requestAnimationFrame(function updateViewportHeight() {
      doc.style.setProperty(customVar, clientHeight * 0.01 + 'px');
      prevClientHeight = clientHeight;
    });
  }

  handleResize();

  return handleResize;
}

window.addEventListener('resize', setViewportProperty(document.documentElement));
